import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/main/App";
import "./style.module.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
